import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import CartSidebar from '../cart/CartSidebar';
import { CartProvider, useCart } from '../../contexts/CartContext';

const LayoutContent: React.FC = () => {
  const { isCartOpen, closeCart } = useCart();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <CartSidebar isOpen={isCartOpen} onClose={closeCart} />
    </div>
  );
};

const Layout: React.FC = () => {
  return (
    <CartProvider>
      <LayoutContent />
    </CartProvider>
  );
};

export default Layout;
